<template>
  <div id="course-outline-registration">
    <component
      :is="layout"
    />
    <!-- {{ state.store.Examination }} -->
    <!-- {{ data }} -->
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { state } from "./data";
import { loadData } from "./data/data-loader";
import { initActions } from "./actions";

export default {
  props: {
    routerProps: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    "layout-default": () => import("./layout-default.vue"),
  },
  computed: {
    layout() {
      return "layout-default";
    },
    state() {
      return state;
    },
    success() {
      return state.store.Examination.success;
    },
    error() {
      return state.store.Examination.error;
    }
  },
  watch: {
    success: async function (data) {
      if (data) {
        this.$vs.notify({ title:'Success', text:'Lorem ipsum dolor sit amet, consectetur', color:'success' });
      }
    },
    error: async function (data) {
      if (data) {
        this.$vs.notify({ itle:'Error', text:'Lorem ipsum dolor sit amet, consectetur', color:'error'});
      }
    },
  },
  methods: {
    async loadData() {
      if (this.routerProps) {
        const { selectedExam } = this.routerProps;
        let examId = this.$route.params.id || (typeof selectedExam !== "undefined" ? selectedExam.id : null);
        if (examId) {
          await loadData({ examId });
        }
      }
      this.$forceUpdate();
    }
  },
  beforeCreate() {
    this._name = "examination-by-subject";
  },
  async created() {
  
    // initActions(this);
    this.loadData();
    // this.state.local.form.input.examId = this.$route.params.id;
  }
}
</script>
